import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation SetMarkerForActivity($activityId: String!, $markerId: String!){
  setMarkerForActivity(activityId: $activityId, markerId: $markerId) {
    id
    markers{
      id
      name
      directory {
        id
        name
      }
    }
  }
}`;

function setMarkerForActivity(activityId, markerId) {
  return apollo.client.mutate({
    variables: {
      activityId,
      markerId: parseInt(markerId, 10),
    },
    mutation,
  }).then((res) => res.data.setMarkerForActivity);
}

export default setMarkerForActivity;
